import { LearningMaterialsContent } from 'api/services/materials';
import { ContentMaterialTypeEnum } from 'types/materials';

export const checkIsExerciseFull = (material: LearningMaterialsContent): boolean => {
    return material.typeOfContent === ContentMaterialTypeEnum.exercise && !isNaN(Number(material.content));
};
